/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react'

import { Helmet } from "react-helmet";
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { parseISO, format } from 'date-fns';

import { useNavigate } from 'react-router-dom';
import Lottie from "lottie-react";

import LoadingContent from '../../modules/loading/LoadingContent';
import blink from '../../../_metronic/assets/animations/blink.json';
import blinkConfirmed from '../../../_metronic/assets/animations/blinkConfirmed.json';

import {
  fetchSchedules,
  fetchSchedulesActive,
} from 'app/services/schedules';

import {
  formatDate,
} from 'app/services/dates';

import PurchaseMenu from 'app/utils/PurchaseMenu';

const ScheduleList = () => {
  const { schedules, auth } = useSelector((state : any) => ({
    schedules: state.schedules,
    auth: state.auth,
  }), shallowEqual);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [listSchedules, setListSchedules] = useState<any>([]);
  const [listSchedulesActive, setListSchedulesActive] = useState<any>([]);

  useEffect(() => {
    dispatch<any>(fetchSchedules(false, false, 'reservation')).then((value) => {
      setListSchedules(value)
    });


    dispatch<any>(fetchSchedulesActive(false, 'reservation')).then((value) => {
      setListSchedulesActive(value)
    });
  }, []);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const scheduleItem = (schedule: any) => {
    return <div className="col-lg-6 mb-1 mb-lg-0">
      <div className="d-flex justify-content-center">
        <div
          className="card card-dashed flex-row flex-stack p-4 mb-6 w-100 cursor-pointer"
          onClick={() => navigate(`/compras/locacao-de-quadra/${schedule.id}`)}
        >
          <div className="d-flex align-items-center me-2">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center fs-2 fw-bold flex-wrap pb-3">{schedule.relationships?.service?.attributes?.name}</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">{formatDate(schedule.attributes.start_at)} às {format(parseISO(schedule.attributes.start_at), 'HH:mm')}  • {schedule.attributes.duration} minutos</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-3">{schedule.relationships.field.attributes.name}</div>

              <div
                className="fs-7 fw-semibold opacity-70 text-hover-primary cursor-pointer zi-10"
              >
                Mais informações
              </div>
            </div>
          </div>
          <div className="d-flex ms-5">
            <div className="flex-grow-1">
              {(schedule.relationships.status.attributes.name == 'confirmed') && <span className="flex d-flex text-primary fs-6 fw-bold justify-content-end pb-15">
                {schedule.attributes.past ? 'Realizado' : 'Confirmado'}
                {!schedule.attributes.past && <Lottie
                  style={{ width: 24 }}
                  animationData={blinkConfirmed}
                  loop={true}
                  autoplay
                />}
              </span>}

              {(schedule.relationships.status.attributes.name == 'pending') && <span className="flex d-flex text-warning fs-6 fw-bold text-center justify-content-end pb-10">
                Pendente
                <Lottie
                  style={{ width: 24 }}
                  animationData={blink}
                  loop={true}
                  autoplay
                />
              </span>}

              {(schedule.relationships.status.attributes.name == 'canceled') && <span className="flex d-flex opacity-50 fs-6 fw-bold text-center justify-content-end pb-10">
                Cancelado
              </span>}
              <span className="flex d-flex fs-7 opacity-50 justify-content-end uppercase">{schedule.relationships.field.relationships.branch.attributes.name}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  return (<>

    <Helmet>
      <title>Minhas compras - Locação de quadra - Atacante App</title>
    </Helmet>

    <PurchaseMenu />

    {<div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0 mb-13'>
        {listSchedulesActive?.length > 0 && <>
          <div className="mb-10">
            <h1 className="mb-3">
              Próximos agendamentos
            </h1>
          </div>
          <div className="row mt-10 mb-5">
            {listSchedulesActive.map(schedule => {
              return scheduleItem(schedule)
            })}
          </div>
        </>}

        {listSchedules?.length > 0 && <>
          <div className="mb-10">
            <h1 className="mb-3">
              Histórico de agendamentos
            </h1>
          </div>
          <div className="row mt-10">
            {listSchedules.map(schedule => {
              return scheduleItem(schedule)
            })}
          </div>
        </>}

        {schedules.listLoading === false && schedules.listActiveLoading === false && listSchedulesActive?.length === 0 && listSchedules?.length === 0 && <div className="my-10 text-center">
          <h2 className="mb-3">
            Ops, Nenhum agendamento por aqui!
          </h2>
          <div className="text-muted fw-semibold fs-5">
            Reserve já sua quadra agora.
          </div>
          <div className="text-muted fw-semibold fs-5">
            Chame seus amigos para jogar!
          </div>
        </div>}

        {(schedules.listLoading === true || schedules.listActiveLoading === true) && listSchedulesActive?.length === 0 && listSchedules?.length === 0 && <LoadingContent />}
      </div>
    </div>}
  </>)
}

export {
  ScheduleList
}
